<template>
  <builderall-loader :loading="loadingAll" class="ba-w-100">
    <div class="card-body ba-w-100">
      <div class="ba-flex ba-jc-fe ba-gp-1">
        <form v-if="items && items.length > 0 && items.find(x => !x.name == false)">
          <div class='ba-box-search-input'>
              <input type='search' class='ba-input' v-model="filtro" :placeholder="$t('ct-search')" />
              <button class='ba-button'>
                  <builderall-icon code='search' />
              </button>
          </div>
        </form>
        <button
          type="button" class="ba-btn ba-blue ba-md"
          @click="newObj"
        >
          <i class="svg-icon svgi-add-circle mr-3"></i
          >{{ $t(`ct-create-new-${title.toLowerCase()}`) }}
        </button>
      </div>
      <section v-if="filterItems && filterItems.length > 0 && filterItems.find(x => !x.name == false)">
        <div v-if="type === 'Popup'" class="exit-popup__total-views">
          <span>{{ $t('ct-popup-list-total-impressions') }}: {{ popupViewsTotal }}</span>
          <a href="https://office.builderall.com/br/office/edit-my-account?tab=quotas" target="_blank">
            <builderall-icon code="help" ba-tooltip-position="left"
                          :ba-tooltip-title="$t('ct-popup-list-total-impressions-tooltip').replace('%impressions_limit%', popupViewsLimit)"></builderall-icon>
          </a>
        </div>
        <table class='ba-table ba-md ba-w-100 ba-lines-all'>
            <thead>
                <tr>
                    <th class="ba-w-30">{{ $t('ct-name') }}</th>
                    <template v-if="type == 'Header'">
                      <th class="ba-w-20">{{ $t('ct-desktop') }}</th>
                      <th class="ba-w-20">{{ $t('ct-mobile') }}</th>
                    </template>
                    <th class="ba-w-30"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="!iten.name == false" v-for="(iten, index) of filterItems" :key="index">
                    <td>
                      <span class="py-1 d-block popup__name">
                        {{ iten.name.length > 55 ? iten.name.substring(0, 55) + "..." : iten.name }}
                      </span>
                      <template v-if="iten.external_host && iten.external_path">
                        <div class="exit-popup">
                          <div class="exit-popup__url">
                            <span>https://{{ iten.external_host }}{{ iten.external_path }}</span>
                            <builderall-icon code="b54c"
                                            @click="copyToClipboard(`https://${iten.external_host}${iten.external_path}`)"
                                            ba-tooltip-position="left" :ba-tooltip-title="$t('ct-copy')"
                            />
                          </div>
                          <span class="py-1 d-block" v-if="type === 'Popup'">
                          <span class="exit-popup__views">{{ $t('ct-popup-list-item-total-impressions') }}: {{ popupViews[iten.id] || 0 }}</span>
                        </span>
                        </div>
                      </template>
                    </td>
                    <template v-if="type == 'Header'">
                      <td>
                        {{ iten.in_use_pages_desktop || 0}}
                      </td>
                      <td>
                        {{ iten.in_use_pages_mobile || 0}}
                      </td>
                    </template>
                    <td>
                      <div class="ba-flex ba-gp-04 ba-jc-fe ba-ai-center">
                        <template v-if="type == 'Header'">
                          <button class="ba-btn ba-btn-normal ba-sm ba-rounded"
                          @click.prevent="openBatchApplyPopup(iten)"
                          ba-tooltip-position='top'
                          :ba-tooltip-title="$t('ct-apply-all-website-page')">
                            <builderall-icon code='94e2'></builderall-icon>
                          </button>
                        </template>
                        <router-link
                          v-if="objects_list === 'multiaction'"
                          :to="{
                            name: 'MultiActionEdit',
                            params: { action_id: iten.action_id },
                          }"
                          class="btn btn-default px-0"
                          target="_blank"
                        >
                          <button
                            ba-tooltip-position='top'
                            :ba-tooltip-title="$t('ct-edit')"
                            class='ba-btn ba-btn-normal ba-sm ba-rounded'
                            >
                              <builderall-icon code='edit' />
                          </button>
                        </router-link>
                        <router-link
                          v-else-if="objects_list === 'powerup'"
                          :to="{
                            name: 'editor-layout-item',
                            params: {
                              id_item: iten.encrypted_id,
                              type: objects_list,
                              website_id: website_id,
                            },
                            query: {
                              is_exit_popup_in_bundle_access: is_exit_popup_in_bundle_access
                            }
                          }"
                          class="btn btn-default px-0"
                        >
                          <button
                            ba-tooltip-position='top'
                            :ba-tooltip-title="$t('ct-edit')"
                            class='ba-btn ba-btn-normal ba-sm ba-rounded'
                            >
                              <builderall-icon code='edit' />
                          </button>
                        </router-link>
                        <router-link
                          v-else
                          :to="{
                            name: 'editor-layout-item',
                            params: {
                              id_item: iten.encrypted_id,
                              type: objects_list,
                              website_id: website_id,
                            },
                            query: {
                              is_exit_popup_in_bundle_access: is_exit_popup_in_bundle_access
                            }
                          }"
                          target="_blank"
                          class="btn btn-default px-0"
                        >
                          <button
                            ba-tooltip-position='top'
                            :ba-tooltip-title="$t('ct-edit')"
                            class='ba-btn ba-btn-normal ba-sm ba-rounded'
                            >
                              <builderall-icon code='edit' />
                          </button>
                        </router-link>
                        <button
                          v-if="type === 'Popup'"
                          class='ba-btn ba-btn-normal ba-sm ba-rounded'
                          ba-tooltip-position='top'
                          :ba-tooltip-title="'Configurations'"
                          @click.prevent="configuration(iten)"
                          >
                            <builderall-icon code="5270"/>
                        </button>
                        <button
                          class='ba-btn ba-btn-normal ba-sm ba-rounded'
                          ba-tooltip-position='top'
                          :ba-tooltip-title="$t('ct-duplicate')"
                          @click.prevent="duplicate(iten)"
                          >
                            <builderall-icon code='b54c' />
                        </button>
                        <button
                          class='ba-btn ba-btn-trash ba-sm ba-rounded'
                          ba-tooltip-position='top'
                          :ba-tooltip-title="$t('ct-exclude')"
                          @click.prevent="openConfirmDelete(iten)"
                          >
                            <builderall-icon code='trash' />
                        </button>
                      </div>
                      <div v-if="(objects_list === 'multiaction') & (iten.id !== 0)">
                        <div class="mr-2">
                          <p>{{ iten.total_counter }}</p>
                          <p>{{ $t(`ct-clicks`) }}</p>
                        </div>
                        <div class="mr-2">
                          <p>{{ iten.partial_counter }}</p>
                          <p>{{ $t(`ct-click-interval`) }}</p>
                        </div>
                      </div>
                    </td>
                </tr>
            </tbody>
        </table>
      </section>

      <!-- Create -->
      <sweet-modal ref="create-template" hide-close-button @close="cleanCreateElement">
        <div class="create-template-popup ba-grid ba-gp-04">
          <div class='ba-flex ba-jc-sb ba-gp-1'>
              <span class='ba-title'>{{ $t('ct-new') }} {{ title }}</span>
              <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closePopup">
                  <builderall-icon code='64f7' />
              </button>
          </div>
          <hr class='ba-hr-row'>
          <div class='ba-content'>
            <div class='ba-box-input'>
              <div class='ba-info'>
                  <label class='ba-label'>{{ $t('ct-name') }}</label>
              </div>
              <input
                type='text'
                maxlength="50"
                class='ba-input'
                v-model="item.name"
                :placeholder="$t('ct-text-go-here')"
              />
            </div>
            <br>
            <div class="ba-flex ba-jc-fe ba-gp-1">
              <button class="ba7-btn-transparent" @click="closePopup">{{ $t('ct-cancel') }}</button>
              <button
                class="ba7-btn-save ba-btn ba-blue ba-md"
                :disabled="!item.name"
                @click="create()"
              >
                {{ $t('ct-save') }}
              </button>
            </div>
          </div>
        </div>
      </sweet-modal>

      <!-- DELETE -->
      <modal-delete-component
        :show="modalDelete.show"
        :text="modalDelete.text"
        :description="modalDelete.description"
        :values="modalDelete.config"
        @cancel="cancelConfirmDelete"
        @exclude="exclude"
      ></modal-delete-component>

      <!-- APPLY APPROVE -->
       <sweet-modal ref="approveTemplate" hide-close-button class="custom-approve-template" width="380px">
        <div class="approve-template-popup ba-grid ba-gp-04">
          <div class='approve-template-header ba-flex ba-ai-center ba-jc-sb ba-gp-1'>
            <div class="ba-flex ba-ai-center ba-gp-1">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5001 6.9036e-10C5.76494 -2.35323e-05 4.08345 0.601599 2.74213 1.70236C1.40082 2.80312 0.482675 4.33491 0.14414 6.03673C-0.194395 7.73855 0.0676265 9.50511 0.885558 11.0354C1.70349 12.5657 3.02672 13.765 4.6298 14.4291C6.23287 15.0931 8.0166 15.1807 9.67705 14.6771C11.3375 14.1734 12.7719 13.1096 13.736 11.6668C14.7 10.2241 15.1339 8.49176 14.9639 6.76495C14.7938 5.03813 14.0303 3.42371 12.8033 2.19675C11.3968 0.790221 9.48921 2.69778e-05 7.5001 6.9036e-10Z" fill="#00C38E"/>
                <path d="M5 7.34213L6.77964 9L10 6" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
              </svg>
              <span class='ba-title'>{{ $t('ct-apply-all-pages') }}</span>
            </div>
              <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="closeBatchPopup">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4277_47536)">
                    <path d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z" fill="#3FC063"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_4277_47536">
                    <rect width="18" height="18" fill="white"/>
                    </clipPath>
                    </defs>
                  </svg>
              </button>
          </div>
          <div class='ba-content'>
            <div class="ba-flex ba-w-100 ba-jc-center">
              <span class="select-device-text">{{ $t('ct-confirm-apply-global-header') }}</span>
            </div>
            <div class="ba-flex ba-gp-1 ba-w-100 ba-jc-center">
              <button class="device-button ba-btn ba-rounded" @click="selectOption('both')"
                :class="{ active: desktop && mobile }"
                ba-tooltip-position='bottom'
                :ba-tooltip-title="$t('ct-mobile-and-desktop')">
                <svg width="22" height="22" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_4415_1162)">
                  <path d="M13.3698 7H9.28237C9.15911 7 9.03706 7.02946 8.9232 7.08669C8.80935 7.14392 8.70592 7.22779 8.61883 7.33352C8.53174 7.43925 8.46271 7.56475 8.41567 7.70285C8.36864 7.84095 8.34453 7.98894 8.34473 8.13834V15.982C8.34473 16.2835 8.44351 16.5726 8.61936 16.7857C8.7952 16.9988 9.03369 17.1186 9.28237 17.1186H13.3698C13.6185 17.1186 13.857 16.9988 14.0328 16.7857C14.2087 16.5726 14.3075 16.2835 14.3075 15.982V8.13834C14.3077 7.98894 14.2835 7.84095 14.2365 7.70285C14.1895 7.56475 14.1204 7.43925 14.0334 7.33352C13.9463 7.22779 13.8428 7.14392 13.729 7.08669C13.6151 7.02946 13.4931 7 13.3698 7ZM13.7112 15.982C13.7112 16.0918 13.6752 16.197 13.6112 16.2746C13.5472 16.3522 13.4604 16.3958 13.3698 16.3958H9.28237C9.19183 16.3958 9.105 16.3522 9.04098 16.2746C8.97697 16.197 8.941 16.0918 8.941 15.982V8.13834C8.9408 8.08385 8.94949 8.02985 8.96656 7.97944C8.98362 7.92903 9.00874 7.8832 9.04046 7.84459C9.07217 7.80597 9.10987 7.77533 9.15139 7.75442C9.1929 7.73352 9.23741 7.72276 9.28237 7.72276H9.44634C9.48456 7.72299 9.52188 7.73681 9.55367 7.76251C9.58547 7.7882 9.61035 7.82464 9.62522 7.86731L9.75044 8.22868C9.77382 8.29361 9.81242 8.34878 9.86145 8.38733C9.91048 8.42588 9.96778 8.44611 10.0262 8.44551H12.6021C12.6583 8.44532 12.7133 8.42588 12.7608 8.38943C12.8083 8.35299 12.8463 8.30102 12.8704 8.23953L13.0195 7.85647C13.0357 7.81583 13.0612 7.78165 13.0928 7.75796C13.1245 7.73426 13.1612 7.72205 13.1984 7.72276H13.3698C13.4148 7.72276 13.4593 7.73352 13.5008 7.75442C13.5423 7.77533 13.58 7.80597 13.6117 7.84459C13.6435 7.8832 13.6686 7.92903 13.6856 7.97944C13.7027 8.02985 13.7114 8.08385 13.7112 8.13834V15.982Z" fill="currentColor"/>
                  </g>
                  <path d="M8.99701 12.4615C9.11561 12.4615 9.22936 12.4146 9.31323 12.3311C9.39709 12.2477 9.44421 12.1345 9.44421 12.0164C9.44421 11.8984 9.39709 11.7852 9.31323 11.7017C9.22936 11.6183 9.11561 11.5714 8.99701 11.5714H8.4134C8.33097 11.5714 8.25192 11.5388 8.19363 11.4808C8.13534 11.4228 8.1026 11.3441 8.1026 11.2621C8.1026 11.108 8.04111 10.9603 7.93166 10.8514C7.82222 10.7425 7.67378 10.6813 7.519 10.6813H6.00297C5.84819 10.6813 5.69975 10.7425 5.5903 10.8514C5.48086 10.9603 5.41937 11.108 5.41937 11.2621C5.41937 11.3441 5.38663 11.4228 5.32834 11.4808C5.27005 11.5388 5.191 11.5714 5.10856 11.5714H4.52496C4.40636 11.5714 4.29261 11.6183 4.20874 11.7017C4.12487 11.7852 4.07776 11.8984 4.07776 12.0164C4.07776 12.1345 4.12487 12.2477 4.20874 12.3311C4.29261 12.4146 4.40636 12.4615 4.52496 12.4615H8.99701Z" fill="currentColor"/>
                  <path d="M11.126 -6.10352e-05C11.6287 4.55701e-05 12.1113 0.198882 12.4668 0.552673C12.8222 0.906454 13.0214 1.38642 13.0215 1.88666V6.92279H12.1162C12.1226 6.87213 12.1269 6.82106 12.127 6.76947V1.88666C12.1269 1.75518 12.1006 1.62521 12.0498 1.50385C11.9989 1.38232 11.925 1.27134 11.8311 1.17865C11.7372 1.08604 11.6254 1.01338 11.5029 0.963806C11.3804 0.914233 11.2485 0.889388 11.1162 0.890564H2.39648C2.13081 0.890564 1.87536 0.995598 1.6875 1.18256C1.49997 1.36939 1.39463 1.62257 1.39453 1.88666V6.76947C1.39459 7.09871 1.52583 7.41459 1.75977 7.6474C1.99375 7.88025 2.31168 8.01068 2.64258 8.01068H8.84766V9.79095H1.95312C1.56776 9.79088 1.19828 9.63832 0.925781 9.36713C0.653307 9.09588 0.5 8.72821 0.5 8.34467H0.513672C0.505225 8.3029 0.500475 8.26031 0.5 8.21771V1.88666C0.500044 1.63824 0.549721 1.39242 0.645508 1.16302C0.741344 0.93353 0.881606 0.725072 1.05859 0.549744C1.23558 0.374434 1.44573 0.235846 1.67676 0.141541C1.90784 0.0472337 2.15552 -0.00123348 2.40527 -6.10352e-05H11.126Z" fill="currentColor"/>
                  <defs>
                  <clipPath id="clip0_4415_1162">
                  <rect width="8.34783" height="10.1186" fill="white" transform="translate(7.15222 7)"/>
                  </clipPath>
                  </defs>
                </svg>
              </button>
              <button class="device-button ba-btn ba-rounded" @click="selectOption('mobile')"
                :class="{ active: mobile && !desktop }"
                ba-tooltip-position='bottom'
                :ba-tooltip-title="$t('ct-mobile')">
                <svg width="22" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9068 0H2.0932C1.82742 -4.10518e-07 1.56426 0.0640457 1.31875 0.188474C1.07325 0.312903 0.850226 0.495272 0.662444 0.725148C0.474661 0.955025 0.325805 1.2279 0.224389 1.52816C0.122974 1.82841 0.0709912 2.15016 0.0714137 2.475V19.5289C0.0714137 20.1843 0.284423 20.8128 0.663581 21.2762C1.04274 21.7397 1.55699 22 2.0932 22H10.9068C11.443 22 11.9572 21.7397 12.3364 21.2762C12.7155 20.8128 12.9286 20.1843 12.9286 19.5289V2.475C12.929 2.15016 12.877 1.82841 12.7756 1.52816C12.6742 1.2279 12.5253 0.955025 12.3375 0.725148C12.1497 0.495272 11.9267 0.312903 11.6812 0.188474C11.4357 0.0640457 11.1725 -4.10518e-07 10.9068 0ZM11.6428 19.5289C11.6428 19.7675 11.5653 19.9964 11.4273 20.1651C11.2892 20.3338 11.102 20.4286 10.9068 20.4286H2.0932C1.89798 20.4286 1.71076 20.3338 1.57272 20.1651C1.43468 19.9964 1.35713 19.7675 1.35713 19.5289V2.475C1.3567 2.35653 1.37543 2.23912 1.41223 2.12952C1.44903 2.01991 1.50319 1.92027 1.57158 1.83632C1.63997 1.75236 1.72126 1.68574 1.81077 1.64028C1.90029 1.59483 1.99627 1.57143 2.0932 1.57143H2.44677C2.52917 1.57194 2.60964 1.60199 2.6782 1.65786C2.74676 1.71372 2.80041 1.79295 2.83249 1.88571L3.10249 2.67143C3.15289 2.81259 3.23612 2.93254 3.34185 3.01636C3.44757 3.10017 3.57112 3.14416 3.69713 3.14286H9.25141C9.37258 3.14244 9.49119 3.10017 9.59356 3.02093C9.69592 2.94169 9.77788 2.82871 9.82999 2.695L10.1514 1.86214C10.1863 1.77378 10.2412 1.69947 10.3095 1.64796C10.3779 1.59645 10.4569 1.5699 10.5371 1.57143H10.9068C11.0037 1.57143 11.0997 1.59483 11.1892 1.64028C11.2787 1.68574 11.36 1.75236 11.4284 1.83632C11.4968 1.92027 11.5509 2.01991 11.5877 2.12952C11.6245 2.23912 11.6433 2.35653 11.6428 2.475V19.5289Z" fill="currentColor"/>
                </svg>
              </button>
              <button class="device-button ba-btn ba-rounded" @click="selectOption('desktop')"
                :class="{ active: desktop && !mobile }"
                ba-tooltip-position='bottom'
                :ba-tooltip-title="$t('ct-desktop')">
                <svg width="22" height="22" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_4415_1165)">
                  <path d="M15.7743 3.03262e-05H3.23857C2.87954 -0.00166321 2.52372 0.0675894 2.19153 0.203811C1.85935 0.340032 1.55735 0.540538 1.30288 0.793812C1.04841 1.04709 0.846488 1.34814 0.708705 1.67968C0.570922 2.01122 0.499996 2.36671 0.5 2.72574V11.8704C0.500682 11.9319 0.507139 11.9932 0.519286 12.0536H0.5C0.5 12.6077 0.72012 13.1391 1.11194 13.5309C1.50375 13.9227 2.03517 14.1429 2.58928 14.1429H16.4107C16.9648 14.1429 17.4962 13.9227 17.888 13.5309C18.2799 13.1391 18.5 12.6077 18.5 12.0536H18.4807C18.4928 11.9932 18.4993 11.9319 18.5 11.8704V2.72574C18.5 2.00284 18.2128 1.30954 17.7016 0.798372C17.1905 0.287203 16.4972 3.03262e-05 15.7743 3.03262e-05ZM17.2143 9.77787C17.2143 10.2536 17.0253 10.7098 16.6889 11.0461C16.3526 11.3825 15.8964 11.5714 15.4207 11.5714H3.57928C3.1036 11.5714 2.6474 11.3825 2.31104 11.0461C1.97468 10.7098 1.78571 10.2536 1.78571 9.77787V2.72574C1.78571 2.34383 1.93743 1.97756 2.20748 1.70751C2.47753 1.43746 2.8438 1.28574 3.22571 1.28574H15.7614C15.9516 1.28404 16.1402 1.32004 16.3164 1.39164C16.4926 1.46325 16.6529 1.56905 16.788 1.70294C16.923 1.83682 17.0303 1.99614 17.1034 2.17169C17.1766 2.34724 17.2143 2.53555 17.2143 2.72574V9.77787Z" fill="currentColor"/>
                  <path d="M12.7144 18C12.8849 18 13.0484 17.9323 13.1689 17.8117C13.2895 17.6912 13.3572 17.5277 13.3572 17.3572C13.3572 17.1867 13.2895 17.0231 13.1689 16.9026C13.0484 16.782 12.8849 16.7143 12.7144 16.7143H11.8754C11.7569 16.7143 11.6433 16.6672 11.5595 16.5834C11.4757 16.4997 11.4286 16.386 11.4286 16.2675C11.4286 16.045 11.3403 15.8316 11.1829 15.6743C11.0256 15.517 10.8122 15.4286 10.5897 15.4286H8.41044C8.18794 15.4286 7.97456 15.517 7.81723 15.6743C7.6599 15.8316 7.57151 16.045 7.57151 16.2675C7.57151 16.386 7.52444 16.4997 7.44065 16.5834C7.35686 16.6672 7.24322 16.7143 7.12473 16.7143H6.2858C6.1153 16.7143 5.95179 16.782 5.83123 16.9026C5.71067 17.0231 5.64294 17.1867 5.64294 17.3572C5.64294 17.5277 5.71067 17.6912 5.83123 17.8117C5.95179 17.9323 6.1153 18 6.2858 18H12.7144Z" fill="currentColor"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_4415_1165">
                  <rect width="18" height="18" fill="white" transform="translate(0.5)"/>
                  </clipPath>
                  </defs>
                </svg>

              </button>
            </div>
            <div class="ba-flex ba-w-100 ba-jc-fe ba-mg-t-1">
              <button class="apply-button" :class="{'apply-button-active': desktop || mobile}" @click="batchApply(currentHeaderItem, mobile, desktop)"
              >{{ $t('ct-apply') }}</button>
            </div>

          </div>
        </div>
      </sweet-modal>

      <modal-create-popup-component ref="modalCreatePopup" @save="createPopup($event)"/>

      <sweet-modal ref="modalPublicationPopup" icon="success">
        {{ $t('ct-your-changes-saved') }}
      </sweet-modal>
    </div>
  </builderall-loader>
</template>

<script>
import ModalDeleteComponent from "../../components/ModalDelete";
import ModalCreatePopupComponent from "../../components/ModalCreatePopup.vue";
import {
  create as createHeader,
  update as updateHeader,
  destroy as deleteHeader,
  batchApply as batchApplyHeader
} from "../../../../js/services/editor/headers";
import {
  create as createFooter,
  update as updateFooter,
  destroy as deleteFooter,
} from "../../../../js/services/editor/footers";
import {
  create as createPopup,
  update as updatePopup,
  destroy as deletePopup,
} from "../../../../js/services/editor/popups";
import {
  create as createPowerup,
  update as updatePowerup,
  destroy as deletePowerup,
} from "../../../../js/services/editor/powerups";
import {
  get as getMultiaction,
  create as createMultiaction,
  update as updateMultiaction,
  destroy as deleteMultiaction,
} from "../../../../js/services/editor/multiactions";
import { get } from "../../../../js/services/editor/layout";
import { SweetModal } from "sweet-modal-vue";

import Errors from "./../../../../js/base/Errors";
import Collapse from "../../components/Collapse.vue";
import {updateVersion} from "../../../../js/services/editor/publish";
import Http from "../../../../js/services/http";

export default {
  name: "Feaders",
  props: ["type", "title", "is_exit_popup_in_bundle_access"],
  components: { SweetModal, ModalDeleteComponent, ModalCreatePopupComponent, Collapse },
  data() {
    return {
      errors: new Errors(),
      items: [],
      website_id: null,
      item: {
        name: "",
        layout_id: null
      },
      modalDelete: {
        show: false,
        config: "",
      },
      layout_id: null,
      getItems: null,
      createItem: null,
      updateItem: null,
      deleteItem: null,
      batchApplyItem: null,
      currentHeaderItem: null,
      mobile: false,
      desktop: false,
      objects_list: null,
      filtro: "",
      loadingAll: false,
      popupViews: {},
      popupViewsTotal: 0,
      popupViewsLimit: Number(10000).toLocaleString()
    };
  },
  watch: {
    type: async function () {
      await this.init();
      await this.updateList();
    },
  },
  methods: {
    init() {
      switch (this.type) {
        case "Header": {
          this.createItem = createHeader;
          this.updateItem = updateHeader;
          this.deleteItem = deleteHeader;
          this.batchApplyItem = batchApplyHeader;
          this.objects_list = "header";
          break;
        }

        case "Footer": {
          this.createItem = createFooter;
          this.updateItem = updateFooter;
          this.deleteItem = deleteFooter;
          this.objects_list = "footer";
          break;
        }

        case "Popup": {
          this.createItem = createPopup;
          this.updateItem = updatePopup;
          this.deleteItem = deletePopup;
          this.objects_list = "popup";
          break;
        }

        case "Powerup": {
          this.createItem = createPowerup;
          this.updateItem = updatePowerup;
          this.deleteItem = deletePowerup;
          this.objects_list = "powerup";
          break;
        }

        case "Multiaction": {
          this.getItems = getMultiaction;
          this.createItem = createMultiaction;
          this.updateItem = updateMultiaction;
          this.deleteItem = deleteMultiaction;
          this.objects_list = "multiaction";
          break;
        }
      }
      this.filtro = "";
    },

    newObj() {
      if (this.type === "Popup") {
        this.empty();
        this.$refs.modalCreatePopup.open();
        return;
      } else {
        this.$refs["create-template"].open();
      }

      if (this.items.length) {
        if (this.items[0].id === 0) {
          return null;
        }
      }

      this.items.unshift({
        id: 0,
        name: "",
      });
    },

    closePopup(){
      this.$refs["create-template"].close();
      this.cleanCreateElement();
    },

    cleanCreateElement(){
      this.item.name = "";
      this.typeToCreate = null;
      // this.items.shift();
    },

    create(copy = false) {
      if (copy) {
        console.log(copy)
        this.item = copy;
        this.item.name += " - copy";
        this.item.encrypted_id = null;
      } else {
        this.item.content = undefined;
      }
      if (this.type === "Multiaction") {
        this.item.website_id = this.$route.params.id;
      }
      if (!this.item.encrypted_id) {
        this.item.layout_id = this.layout_id;
      }
      if (!this.validate()) {
        this.loadingAll = true;
        const editing = this.item.encrypted_id;
        (editing ? this.updateItem : this.createItem)(this.item)
          .then((res) => {
            if(res.data.success){
              this.closePopup();
              this.$snotify.success(this.$t("ct-saved-successfully"));
              this.updateList();
              if (this.type === "Popup") {
                // updateVersion(this.website_id);
                if (editing) {
                  this.$refs.modalPublicationPopup.open();
                } else {
                  const routeData = this.$router.resolve({
                    name: "editor-layout-item",
                    params: {
                      type: this.objects_list,
                      id_item: res.data.data.encrypted_id,
                      website_id: this.$route.params.id,
                    },
                    query: {
                      is_exit_popup_in_bundle_access: this.is_exit_popup_in_bundle_access
                    }
                  });
                  window.open(routeData.href, '_blank');
                }
              }
            } else {
              this.$snotify.error(this.$t(`ct-item-name-required`));
            }
          })
          .finally(() => {
            this.loadingAll = false;
          });
        this.empty();
      } else {
        this.$snotify.error(this.$t(`ct-item-name-required`));
      }
    },

    createPopup(item) {
      this.item = this.item ? {...this.item, ...item} : item;
      this.create();
    },

    validate() {
      this.errors = new Errors();
      if (!this.item.name && !(this.item.name.length > 0)) {
        this.errors.add("name", "validation-required", "item");
      }

      return this.errors.any();
    },

    updateList() {
      this.$loading.show();

      if (this.type === "Multiaction") {
        this.getItems(this.$route.params.id)
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => this.$loading.hide());
      } else {
        get(this.layout_id)
          .then((response) => {
            this.items = response.data[this.objects_list + "s"];
            this.website_id = response.data.website.encrypted_id;
          })
          .finally(() => this.$loading.hide());
        if (this.type === "Popup") {
          Http.authApi()
            .get(`/external-popup/${this.layout_id}/views`)
            .then(response => {
              this.popupViews = response.data || {};
              this.popupViewsTotal = Object.values(this.popupViews)
                .reduce((total, views) => total + views, 0);
            });
        }
      }
    },

    empty() {
      this.item = {
        name: "",
        layout_id: this.layout_id,
      };
      this.errors.clear();
    },

    exclude(item) {
      this.$loading.show();
      this.deleteItem(item)
        .then((res) => {
          this.modalDelete.show = false;
          this.modalDelete.config = "";
          this.updateList();
        })
        .finally(() => this.$loading.hide());
    },

    openConfirmDelete(config) {
      this.modalDelete.show = true;
      this.modalDelete.config = config;
    },

    cancelConfirmDelete() {
      this.modalDelete.show = false;
      this.modalDelete.config = "";
    },

    duplicate(item) {
      this.$loading.show();
      if (this.type === "Multiaction") {
        item.website_id = this.$route.params.id;
      }
      this.create(item);
    },
    selectOption(type) {
      switch (type) {
        case 'both':
          this.desktop = true;
          this.mobile = true;
          break;
        case 'mobile':
          this.mobile = true;
          this.desktop = false;
          break;
        case 'desktop':
          this.desktop = true;
          this.mobile = false;
          break;
        default:
          console.warn('Opção inválida:', type);
      }
    },

    openBatchApplyPopup(item){
      this.mobile = false;
      this.desktop = false;
      this.currentHeaderItem = item
      this.$refs.approveTemplate.open()
    },
     closeBatchPopup(){
      this.currentHeaderItem = null;
      this.mobile = false;
      this.desktop = false;
      this.$refs["approveTemplate"].close();
    },

  async batchApply(item, mobile, desktop) {
  try {
    await this.batchApplyItem(item, mobile, desktop);
    this.$refs["approveTemplate"].close();
    this.$snotify.success(this.$t("ct-saved-successfully"));
    this.updateList();
  } catch (error) {
    console.error('Erro ao executar batchApplyItem:', error);
  }
},

    configuration(item) {
      this.item = item;
      this.$refs.modalCreatePopup.open(item);
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
  },
  async created() {
    this.loadingAll = true;
    this.layout_id = this.$route.params.layout_id;

    await this.init();
    await this.updateList();
    this.loadingAll = false;
  },
  computed: {
    filterItems() {
      return this.items.filter((item) => {
        return item.name.match(this.filtro);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  header form {
    position: relative;
    height: 47px;
    margin-right: 20px;

    i {
      position: absolute;
      left: 20px;
      top: 15px;
    }

    input {
      height: -webkit-fill-available;
      padding-left: 45px;
    }
  }

  section {
    .group-tags-desc {
      color: #5a5959;
      font-size: 16px;
      margin-left: 0.25rem;
    }

    .card-tags-group {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: end;

      .card-header {
        font-size: 18px;
        color: #0080fc;
        font-weight: 700;
        border: none !important;
        flex: 1;
        overflow-x: hidden;

        span {
          overflow-wrap: normal;
          overflow-x: hidden;
          white-space: nowrap;
        }
      }

      form input {
        border: none;
        background: transparent;
      }

      .card-body {
        text-align: right;
        padding: 0.75rem;
        flex: none;
        border: none;

        button:after {
          display: none;
        }
      }

      &.p-3 {
        color: #5a5959;
        font: Muli;
        font-size: 13px;
        font-weight: 600;

        p {
          margin: 0;

          &:last-child {
            color: #908d8d;
            font-size: 12px;
            font-style: italic;
          }
        }
      }
  }

  .sombra {
    box-shadow: 0 0 0 100vw #59607175;
    z-index: 2;
  }

  .btn-grey {
    background: #fcfcfc;
    padding: 25px 0 !important;
    font-weight: 600 !important;
  }

  > div > .col-12.text-center {
    color: #5a748b;
    font-size: 20px;
    font-family: "Muli";
  }
}

.create-template-popup{
  label{
    margin-bottom: 0;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    color: #111827;
  }
  .ba-title{
    color: #0072E1;
    font-family: Montserrat;
    font-size: 22px;
    font-weight: 600;
    line-height: 24.2px;
  }
  .ba-btn-close{
    builderall-icon{
      --builderall-icon-size: 22px;
    }
  }
  .ba-content{
    margin-top: 16px;
  }
  .ba7-btn-transparent{
    background: transparent;
    border: none;
    outline: none;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    color: #4D5D71;
  }
  .ba7-btn-save{
    width: 150px;
  }
}
button{
  outline: none;
}
.builderall-icon-edit {
  height: 20px;
  width: 20px;
  --builderall-icon-color: #0380fc;

  builderall-icon {
    transform: scale(1.35);
  }
}

.card-popup {
  display: flex;
  flex-direction: column !important;

  .card-header, .card-body, .card-popup-url {
    width: 100%;
  }

  .card-header {
    padding-bottom: 0;
  }

  .card-popup-url {
    display: flex;
    padding: 0 1.25rem;

    span {
      flex: 1;
      overflow: hidden;
      color: #54779E;
      text-overflow: ellipsis;
      font-family: Montserrat, sans-serif;
      font-size: 14px;
      font-weight: 500;
    }

    builderall-icon {
      width: 18px;
      height: 18px;
      --builderall-icon-color: #425E7D;
      cursor: pointer;

      &:hover {
        --builderall-icon-color: #0380fc;
      }
    }
  }

  .card-body {
    display: block !important;
  }
}

.popup__name {
  color: #4D5D71;
  font-size: 13px;
  font-weight: 700;
}

.exit-popup {
  .exit-popup__url {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #54779E;
    font-size: 14px;

    builderall-icon {
      width: 18px;
      height: 18px;
      --builderall-icon-color: #0380fc;
      cursor: pointer;
    }
  }

  .exit-popup__views {
    color: #4D5D71;
    font-size: 13px;
    font-weight: 700;
  }
}

.exit-popup__total-views {
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    color: #4D5D71;
    font-size: 13px;
    font-weight: 700;
  }

  builderall-icon {
    width: 22px;
    height: 22px;
  }
}
.select-device-text{
  text-align: center;
  font-size: 12px !important;
  margin: 10px 0px 16px 0px;
}
.device-button{
  padding: 10px !important;
  width: 34px !important;
  height: 34px !important;
  color: #8E9EB5 !important;
  &.active {
  background: #007bff;
  color: white !important;
}
&:hover {
  background: #007bff;
  color: white !important;
}
}
.apply-button{
  background-color: #486688;
  opacity: 0.5;
  color: white;
  padding: 4px 40px;
  border: none;
  border-radius: 4px;
  pointer-events: none;
}
.apply-button-active{
    background-color: #3FC063 !important;
    opacity: 1 !important;
    pointer-events: all !important;
    cursor: pointer;
  }

  .ba-w-30 {
  width: 30%;
}

.ba-w-20 {
  width: 20%;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/items/FootersHeadersPopups.vue